<template>
  <fragment>
    <div
      tabindex="-1"
      role="dialog"
      class="modal modal-side-drawer-filters fade fixed-end op"
    >
      <div
        role="document"
        class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Advanced Search</h2>
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true"><i class="far fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="data-filters">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <label>Dependency</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fal fa-search"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      :value="filters.search"
                      @input="updateSearch"
                    />
                  </div>
                </div>
                <div class="col-6 col-lg-3">
                  <label>Platform</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fal fa-layer-group"></i>
                    </span>

                    <multiselect
                      label="label"
                      :options="platformOptions"
                      :show-labels="false"
                      placeholder
                      v-model="platformSelected"
                      track-by="value"
                    />
                  </div>
                </div>
                <div class="col-6 col-lg-3">
                  <label>Branch</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fal fa-code-branch"></i>
                    </span>

                    <select-branch v-model="filters.branch"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul class="list-data no-links">
      <li class="data-heading d-none d-xl-block">
        <div class="row">
          <div class="col-12 col-xl-3">
            <p>Dependency</p>
          </div>
          <div class="col-4 col-xl-2">
            <p>Installed</p>
          </div>
          <div class="col-4 col-xl-2">
            <p>Available</p>
          </div>
          <div class="col-4 col-xl-2">
            <p>Latest</p>
          </div>
          <div class="col-12 col-xl-3">
            <p>Vulnerabilities</p>
          </div>
        </div>
      </li>
      <dependency-item v-for="dependency in dependencies" :key="dependency.id" v-bind="{ dependency, branch: filters.branch }"/>
    </ul>
  </fragment>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import Multiselect from 'vue-multiselect'
import DependencyItem from './DependencyItem'
import SelectBranch from './SelectBranch'

export default {
  mixins: [useQueryParamFilters()],

  components: {
    Multiselect,
    DependencyItem,
    SelectBranch
  },

  data () {
    return {
      filters: {
        branch: 'staging',
        platform: null,
        search: null
      },
      platformOptions: [
        { value: null, label: 'All' },
        { value: 'packagist', label: 'Packagist (PHP)' },
        { value: 'npm', label: 'NPM' }
      ]
    }
  },

  computed: {
    ...mapState('applications', {
      application: 'single'
    }),
    ...mapState('applications/dependencies', ['dependencies']),

    platformSelected: {
      get () {
        return this.platformOptions.find(({ value }) => value === this.filters.platform)
      },

      set ({ value }) {
        this.filters.platform = value
      }
    }
  },

  watch: {
    queryParams: {
      async handler (params) {
        await this.getDependencies(params)
      },
      deep: true,
      immediate: true
    }
  },

  beforeDestroy () {
    this.resetDependencies()
  },

  methods: {
    ...mapActions('applications/dependencies', ['getDependencies', 'resetDependencies']),

    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  }
}
</script>
